module.exports = __webpack_public_path__ + "img/Sedan_Back_Side_Left.bc230307.svg";